<div class="container-fluid service-bg from-top-pad">
    <!-- Titles -->
    <div class="row" *ngIf="!data">
        <div class="col-md-12">
            <h1>
                <a href="#/account">{{'gen_my_account' | translate}}</a> / {{'gen_change_pwd' | translate}}
            </h1>
            <hr>
        </div>
    </div>

    <!-- Email Form -->
    <div class="row">
        <div class="col-md-12">
            <h3 class="text-center" *ngIf="dialogRef">{{'gen_change_pwd' | translate}}</h3>
            <p class="text-center"> {{'account_change_password_msg' | translate}} </p>
        </div>

        <!-- Form -->
        <div class="form-group mx-auto login-form mt-0" [formGroup]="pwdGroup">
            <!-- Old Password -->
            <mat-form-field class="form-element" appearance="fill">
                <mat-label>{{'gen_old_pwd' | translate}}</mat-label>
                <input [type]="hidePwd[0] ? 'password' : 'text'" matInput placeholder="{{'gen_old_pwd' | translate}}"
                    formControlName="oldPassword">
                <mat-icon matSuffix (click)="hidePwd[0] = !hidePwd[0]">{{hidePwd[0] ? 'visibility_off' : 'visibility'}}
                </mat-icon>

                <!-- Errors -->
                <mat-error *ngIf="pwdGroup.controls.oldPassword.errors?.required">{{'error_required_error' | translate}}
                </mat-error>
            </mat-form-field>

            <!-- New Password -->
            <mat-form-field class="form-element" appearance="fill">
                <mat-label>{{'gen_new_password' | translate}}</mat-label>
                <input [type]="hidePwd[1] ? 'password' : 'text'" matInput
                    placeholder="{{'gen_new_password' | translate}}" formControlName="password">
                <mat-icon matSuffix (click)="hidePwd[1] = !hidePwd[1]">{{hidePwd[1] ? 'visibility_off' : 'visibility'}}
                </mat-icon>

                <!-- Errors -->
                <mat-error *ngIf="pwdGroup.controls.password.errors?.required">{{'error_required_error' | translate}}
                </mat-error>
                <mat-error *ngIf="pwdGroup.controls.password.errors?.pattern">{{'error_password_regex' | translate}}
                </mat-error>
            </mat-form-field>

            <!-- Confirm New Password -->
            <mat-form-field class="form-element" appearance="fill">
                <mat-label>{{'gen_confirm_password' | translate}}</mat-label>
                <input [type]="hidePwd[2] ? 'password' : 'text'" matInput
                    placeholder="{{'gen_confirm_password' | translate}}" formControlName="confirmPassword">
                <mat-icon matSuffix (click)="hidePwd[2] = !hidePwd[2]">{{hidePwd[2] ? 'visibility_off' : 'visibility'}}
                </mat-icon>

                <!-- Errors -->
                <mat-error *ngIf="pwdGroup.controls.confirmPassword.errors?.required">{{'error_required_error' |
                    translate}}</mat-error>
                <mat-error *ngIf="pwdGroup.controls.confirmPassword.errors?.pattern">{{'error_password_regex' |
                    translate}}</mat-error>
                <mat-error *ngIf="pwdGroup.controls.confirmPassword.errors?.confirmedValidator">
                    {{'error_confirm_missmatch' | translate}}</mat-error>
            </mat-form-field>

            <!-- Action Button -->
            <button class="button w-100" (click)="changePassword()" [disabled]="pwdGroup.status == 'INVALID'">
                <i class="pr-1 fa fa-key"></i>
                {{'gen_change_pwd' | translate}}
            </button>
        </div>
    </div>
</div>